import React, { ReactNode, useState } from "react";
import { Navigate } from "react-router-dom";
import styled from "@emotion/styled";

import { isSessionValid } from "pages/Auth/Cogcognito";
import Sidebar from "components/sidebar";
import { PageContent } from "components/page-content/page-content.component";
import Menubar from "components/menubar/menubar.component";

export const MainLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: var(--mega-color-gray100);
`;

const MainContent = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex: 1;
  height: 100%;
  // max-width: 1800px;
  margin: auto;
  overflow: hidden;
`;

interface PrivateRouteProps {
  orgSelection?: any;
  children: ReactNode;
}

const PrivateRoute = ({ children, orgSelection }: PrivateRouteProps) => {
  const isAuthenticated = isSessionValid();
  const [showDrawer, setShowDrawer] = useState(false);

  const getDirectPage = () => {
    if (isAuthenticated) {
      if (orgSelection) {
        return children;
      }
      return (
        <MainLayout>
          <Menubar toggleDrawer={() => setShowDrawer(!showDrawer)} />
          <MainContent>
            <Sidebar showDrawer={showDrawer} onCloseDrawer={() => setShowDrawer(false)} />
            <PageContent>{children}</PageContent>
          </MainContent>
        </MainLayout>
      );
    }
    return <Navigate to="/login" />;
  };

  return getDirectPage();
};

export default PrivateRoute;
